import styled from "styled-components";
import { Image as AntImage } from "antd";
import { WarningFilled, IMG_QR } from "@assets";

export const MainContainer = styled.div`
  position: relative;
  min-height: 100vh;
`;
export const RootContainer = styled.div`
  padding: 16px 0px;

  .ant-collapse {
    background-color: #fff;
    border: 1px solid #e1cce0;

    .ant-image {
      margin-bottom: 12px;
    }
  }

  .ant-collapse-header {
    flex-direction: row-reverse;
  }

  .ant-collapse-header-text {
    font-size: 14px;
    font-weight: bold;
  }

  @media screen and (max-width: 320px) {
    padding: 16px 8px;
  }
`;

export const Text = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
`;

export const DigitBox = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-gap: 12px;
  text-align: center;

  .ant-space {
    gap: 4px !important;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  position: relative;
  margin-left: 16px;
  margin-right: 16px;

  .ant-btn {
    height: 52px;
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledInput = styled.input`
  width: 20px !important;
  height: 30px !important;
  border-radius: 8px !important;
  text-align: center !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "#D9D9D9")} !important;
  font-size: 17px !important;
  background: #d9d9d9;
  -moz-appearance: textfield;
  appearance: textfield;

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const SlideImage = styled.img.attrs({
  alt: "slide-img",
})`
  width: 100%;
  height: auto;
  object-fit: cover;
  cursor: pointer;
`;

export const SimpleSlideImage = styled.img.attrs({
  alt: "slide-img",
})`
  width: 278px;
  height: 127px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 8px;
`;

export const EmptyBox = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;

  .ant-btn-primary {
    height: 52px;
  }
`;

export const EmptyText = styled.div`
  padding: 0 15%;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #13100f;

  @media screen and (max-width: 360px) {
    padding: 0 12%;
  }
`;

export const WarningImage = styled(WarningFilled)`
  width: 50px;
  height: 50px;
`;

export const Container = styled.div`
  border-radius: 16px;
  background: #deedff;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-left: 16px;
  margin-right: 16px;
`;

export const Box = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px auto;
  background: #ffffff;
  padding: 10px 10px 8px 10px;
  border-radius: 16px;
`;

export const ImageBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 0.3;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 52px;
  border-radius: 10px;
`;

export const SmallText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  text-align: center;

  @media screen and (max-width: 325px) {
    font-size: 11px;
  }
  padding-top: 8px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #004f9c;
  text-align: center;

  @media screen and (max-width: 325px) {
    font-size: 12px;
  }
`;

export const GrayText = styled.span`
  font-size: 12px;
  font-weight: normal;
  color: ${(props) => props.theme.textColor};
  text-align: left;

  @media screen and (max-width: 325px) {
    font-size: 11px;
  }
`;

export const TextWrapper = styled.div`
  padding: 0px 16px 16px 16px;
  font-size: 12px;
  font-weight: 400px;
  color: #000;
`;

export const AccountInfo = styled.div`
  width: 93%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  flex: 0.5;

  ${Text} {
    color: #000;
    font-size: 14px;
    text-align: left;
    display: flex;
    align-items: center;

    @media screen and (max-width: 363px) {
      font-size: 11px;
    }
    @media screen and (max-width: 306px) {
      font-size: 9px;
    }
  }

  #name {
    font-weight: 400;
    padding-bottom: 5px;
  }
  #phone {
    font-weight: 600;
    font-size: 16px;
  }
`;

export const CopyContainer = styled.div`
  flex: 0.5;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 25px;
  gap: 8px;

  svg {
    width: 25px;
    height: 25px;
  }
`;

export const Copy = styled.div`
  color: #0095da;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  width: 100%;

  @media screen and (max-width: 363px) {
    font-size: 11px;
  }
  @media screen and (max-width: 306px) {
    font-size: 9px;
  }
`;

export const QRCodeContainer = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  border-radius: 8px;
  gap: 60px;
  background: #ffffff;
  padding: 10px 10px 8px 10px;
  border-radius: 16px;
  margin: 16px auto;

  @media screen and (max-width: 450px) {
    gap: 0px;
    justify-content: space-between;
  }
`;

export const QRCodeImage = styled(AntImage).attrs({
  alt: "QR",
  src: IMG_QR,
  preview: false,
})`
  width: 60px !important;
  padding-left: 10px;
`;

export const QRCodeText = styled.div`
  color: #fff;
  font-size: 12px;
  line-height: 15px;
  cursor: pointer;
  background: linear-gradient(90deg, #0060be 0%, #04aeed 100%);
  padding: 8px 10px;
  border-radius: 18px;

  @media screen and (max-width: 350px) {
    font-size: 10px;
  }
`;

export const Wrapper = styled.div`
  min-width: 60px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const SimpleButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  border-radius: 18px;
  background: linear-gradient(90deg, #0060be 0%, #04aeed 100%);
  padding: 6px 16px;
  flex: 0.3;

  cursor: pointer;

  @media screen and (max-width: 322px) {
    font-size: 10px;
  }
`;

export const DigitTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 93%;
  gap: 8px;
  margin-top: 10px;

  @media screen and (max-width: 322px) {
    gap: 4px;
  }
`;

export const DigitText = styled.div`
  background: #d9d9d9;
  border-radius: 18px;
  font-size: 12px;
  font-weight: 400;
  padding: 3px 16px;
  flex: 0.7;
  padding: 6px;

  @media screen and (max-width: 322px) {
    font-size: 10px;
  }
`;

export const UploadText = styled.p`
color: #0161BF;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
`

export const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const ColFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex;
`

export const BlackText = styled.p`
color:  #000;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: normal;
`

export const ChangeBtn = styled.div`
  margin-bottom: 26px;

  color: #0161BF;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const ScreenShotBox = styled.div`
  margin: 24px 0 0;
  padding: 0 16px;
`

export const PalePurpleWrapper = styled.div`
  margin: 12px 0 24px;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid #0161BF;
  background: #DEEDFF !important;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

  svg{
    width: 24px;
    height: 24px;
  }
`

export const SSWarningText = styled.div`
  color: #23AB41;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`